import { atom } from 'recoil';

export const routeUpdateState = atom({
  key: 'routeUpdateState',
  default: false,
});
